import { PortalStyleConfig } from '@nx-frontend/shared/types';
import { TailwindRounded, tailwindRounded } from '@nx-frontend/shared/types/tailwind-class-name';

export function getRoundedClassNames({ radius: { className } }: PortalStyleConfig, shift = 0): TailwindRounded[] {
  if (shift === 0) {
    return className;
  }

  const index = tailwindRounded.findIndex((name) => className.includes(name));
  return [tailwindRounded[Math.max(0, Math.min(tailwindRounded.length - 1, index + shift))]];
}
